import { formatUrlId, parseUrlId } from '@cargoflow/validators'
import { createFileRoute } from '@tanstack/react-router'
import { LoadsDetailPage } from '@/features/loads/loads-detail-page'

export const Route = createFileRoute('/_authenticated/loads/$load_id/edit')({
  params: {
    parse: ({ load_id }) => ({ load_id: parseUrlId(load_id) }),
    stringify: ({ load_id }) => ({ load_id: formatUrlId('LD', load_id) }),
  },
  component: LoadsDetailPage,
})
